<template>
  <div>
    <section class="search-results container my-5">
      <div class="row">
        <div class="col">
          <div class="search-results--header">
            <div class="brand">
              <span class="of-sprite van"></span>
              <span class="of-sprite car"></span>
            </div>
            <div class="engine">
              <span class="of-sprite engine"></span>
            </div>
            <div class="from">
              <span class="of-sprite calender"></span>
            </div>
            <div class="fuel-type">
              <span class="fuel-type-icon"></span>
            </div>
            <div class="info">
              <span class="of-sprite i"></span>
            </div>
            <div class="gas">
              <span class="of-sprite cooling"></span>
            </div>
            <div class="ref">
              <span class="of-sprite gr"></span>
            </div>
            <div class="tolerance">
              <span class="of-sprite plus-minus"></span>
            </div>
            <div class="oil">
              <span class="of-sprite oil"></span>
            </div>
            <div class="oil-quantity">
              <span class="of-sprite ml"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(result, i) in results" :key="result.id" class="row">
        <div class="col">
          <div class="search-results--items" v-b-toggle="`collapse-result-${i}`">
            <div class="bold">{{result.make}}</div>
            <div class="bold">{{result.model}}</div>
            <div>{{result.engine_version}}</div>
            <div>{{result.manufactured_from}}</div>
            <div>{{result.fuel_type | formatFuelType}}</div>
            <div>{{result.info}}</div>
            <div>{{result.gas}}</div>
            <div>{{result.refrigerant_quantity}}</div>
            <div>{{result.refrigerant_quantity_tolerance}}</div>
            <div>{{result.oil}}</div>
            <div>{{result.oil_quantity}}</div>
          </div>
          <b-collapse :id="`collapse-result-${i}`">
            <div class="search-results--actions">
              <b-icon @click="print(result.id)" icon="printer" class="text-xl text-secondary pointer mr-3"></b-icon>
              <b-icon v-b-modal="`modal-send-${result.id}`" icon="envelope" class="text-xl text-secondary pointer"></b-icon>
              <b-modal :id="`modal-send-${result.id}`" :title="$t('forms.send')" title-class="bold text-md" hide-footer>
                <OilGasFinderSendForm :oilId="result.id" />
              </b-modal>
            </div>
          </b-collapse>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import OilGasFinderSendForm from '@/components/oil-gas-finder/OilGasFinderSendForm.vue';
import FormatFuelType from '@/filters/FormatFuelType';

export default {
  components: {
    OilGasFinderSendForm,
  },
  props: {
    results: null,
  },
  data() {
    return {
      isPrinting: false,
    };
  },
  methods: {
    print(oilId) {
      const routeData = this.$router.resolve({ name: 'Oil Gas Finder Print', query: { oilId } });
      window.open(routeData.href, '_blank');
    },
  },
  filters: {
    FormatFuelType,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.search-results {
  &--header {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid $primary;
    margin-bottom: 15px;
    > div.brand {
      width: 20%;
    }
    > div {
      width: 10%;
      padding: 10px 15px;
    }
  }
  &--items {
    display: flex;
    &.not-collapsed {
      > div {
        &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4) {
          background-color: #efeff0;
        }
        &:nth-child(5) {
          background-color: $green;
          color: white;
          font-weight: bold;
        }
        &:nth-child(6) {
          background-color: #DDE5EC;
        }
        &:nth-child(7), &:nth-child(8), &:nth-child(9) {
          background-color: #dbf1fc;
        }
        &:nth-child(10), &:nth-child(11) {
          background-color: #f2dbe1;
        }
      }
    }
    > div {
      @extend .text-xs;
      width: 10%;
      padding: 15px;
      margin-bottom: 5px;
      cursor: pointer;
      font-weight: 400;
      transition: all .3s ease-in-out;
      word-break: break-word;
      &:nth-child(1), &:nth-child(2) {
        font-weight: bold;
      }
      &:nth-child(1), &:nth-child(7), &:nth-child(10) {
        border-radius: 5px 0 0 5px;
      }
      &:nth-child(4), &:nth-child(9), &:nth-child(11) {
        border-radius: 0 5px 5px 0;
      }
      &:nth-child(4), &:nth-child(9) {
        margin-right: 5px;
      }
      &:nth-child(5), &:nth-child(6) {
        border-radius: 5px;
        margin-right: 5px;
      }
    }
  }
  &--actions {
    background: #f6f6f5;
    background-image: linear-gradient(to bottom, white 0%, #f6f6f5 100%);
    padding: 5px 10px;
    svg {
      &:focus {
        outline: 0;
      }
    }
  }
  @include media-breakpoint-down (md) {
    display: none;
  }
}
</style>
